// TODO: this should be in it's own package (Copied from RosterFrontEndStaticWebsiteReact)
import * as KatalMetrics from "@amzn/katal-metrics";
import metricsSlice, { MetricsState as MetricsStateType } from "./metricsSlice";

const metrics = KatalMetrics.Metric;
const { actions, reducer, selectors } = metricsSlice;

export { actions, reducer, selectors };
export { EMPTY_METRICS_STATE } from "./metricsSlice";
export type MetricsState = MetricsStateType;
export { metrics as MetricType };
export { default as useMetricsPublisher } from "./useMetricsPublisher";

export { default as errorHandler } from "./errorHandler";
export { default as reduxErrorMiddleware } from "./reduxErrorMiddleware";
